const proxyUrl = 'http://localhost:8087'
module.exports = {
	proxyUrl,
	baseUrl: process.env.NODE_ENV === 'development' ? '/api' : proxyUrl,
}
